import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=fdb9ba18&scoped=true"
import script from "./ModalComponent.vue?vue&type=script&lang=js"
export * from "./ModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalComponent.vue?vue&type=style&index=0&id=fdb9ba18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb9ba18",
  null
  
)

export default component.exports